import React from 'react'
import { CreateForm, Head, Header } from './components'

const CreateStudent = () => {
	return (
		<div className='sm:p-6 p-3'>
			<Head />
			<Header />
			<CreateForm />
		</div>
	)
}

export default CreateStudent
